import withScope from 'ia-react-core/~/hocs/redux/withScope';
import withUniqueId from 'ia-react-core/~/hocs/helpers/_withUniqueId/withUniqueId';
import injectSaga from '../../../hocs/redux/injectSaga';
import compose from '../../../utils/components/_compose';

import ResourceAlias, { ResourceAliasComposedProps, ResourceAliasProps } from './ResourceAlias';
import ResourceAliasSaga from './ResourceAlias.saga';

export * from './ResourceAlias';

const ComposedResourceAlias: (<Data, Error = {}>(
  props: ResourceAliasProps<Data, Error>
) => React.ReactElement<ResourceAliasProps<Data, Error>>) & {
  displayName: string;
  type: typeof ResourceAlias.type;
  publicProps: typeof ResourceAlias.publicProps;
} = compose<any>(
  withUniqueId('resourceAliasId'),
  withScope,
  injectSaga<ResourceAliasComposedProps<{}>>({
    key: ({ resourceAliasId }) => `ResourceAlias${resourceAliasId}`,
    saga: ResourceAliasSaga,
  }),
)(ResourceAlias);

ComposedResourceAlias.displayName = 'ResourceAlias';
ComposedResourceAlias.type = ResourceAlias.type;

export default ComposedResourceAlias;
